import React, { useEffect } from 'react';
import HeroStyle5 from '../Hero/HeroStyle5';
import Section from '../Section';
import MovingTextSection from '../Section/MovingTextSection';
import AboutUsSection from '../Section/AboutSection';
import FunfactSection from '../Section/FunfactSection';
import ContactSection from '../Section/ContactSection';
import { pageTitle } from '../../helpers/PageTitle';
import FranchiseForm from './FranchiseForm';
import FranchiseFormn from './FranchiseFormn';

import TestimonialSection from '../Section/TestimonialSection';
import TeamSection from '../Section/TeamSection';
import { FaArrowRight } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import './PortfolioPage.css'
import ServicesSection from './ServicesSectionHome';

const movingTextData = [
  '* Premium Solar Solutions *',
  '* EV Charging Stations *', 
  '* Sustainable Energy *',
  '* Franchise Opportunities *',
];



const teamData = [
   {
    imgUrl: "https://i.ibb.co/N2Br24SG/Priyanka-Malik.jpg",
    name: "Priyanka Malik",
    designation: "HR Manager",
  },
  {
    imgUrl: "https://i.ibb.co/dJpQLdGV/Vijay-Roy.jpg",
    name: "Vijay Roy",
    designation: "Team Leader",
  },
  {
    imgUrl: "https://i.ibb.co/HTm2T440/Sanskar-Singh.jpg",
    name: "Sanskar Singh",
    designation: "Sales Manager",
  },
 
];

const testimonialData = [
  {
    imgUrl: "/images/avatar_1.png",
    rating: "4.9",
    desc: "Riyansh Solar transformed our factory’s energy setup. We’re saving up to 40% on power costs monthly!",
    name: "Ankit Verma",
    designation: "Industrial Client",
  },
  {
    imgUrl: "/images/avatar_2.png",
    rating: "4.8",
    desc: "Highly professional team and seamless solar installation experience. Truly satisfied with their service.",
    name: "Meera Singh",
    designation: "Residential Client",
  },
  {
    imgUrl: "/images/avatar_3.png",
    rating: "5",
    desc: "Their franchise program helped me start my solar business successfully with complete technical support.",
    name: "Rajesh Kumar",
    designation: "Franchise Partner",
  },
];


const funfactData = [
  {
    iconUrl: '/images/icons/funfact_icon_1.svg',
    funfactNumber: '1.8',
    title: 'Happy Clients',
  },
  {
    iconUrl: '/images/icons/funfact_icon_2.svg',
    funfactNumber: '2',
    title: 'Project Done',
  },
  {
    iconUrl: '/images/icons/funfact_icon_3.svg',
    funfactNumber: '1',
    title: 'Awards Win',
  },
  {
    iconUrl: '/images/icons/funfact_icon_4.svg',
    funfactNumber: '70000+',
    title: 'Profit Gain',
  },
];


const portfolioItems = [
  { 
    type: 'image', 
    src: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80', 
    title: 'Commercial Solar Installation' 
  },
  { 
    type: 'video', 
    src: 'https://www.youtube.com/embed/j5i--kxqjv8', 
    title: 'Solar Installation Process' 
  },
  { 
    type: 'image', 
    src: 'https://images.unsplash.com/photo-1613665813446-82a78c468a1d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2058&q=80', 
    title: 'Residential Rooftop Solutions' 
  },
];

export default function Home5() {
  pageTitle('Riyansh Solar Power Plus - Premium Solar Solutions');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <>
    <FranchiseFormn/>
      <HeroStyle5
        bgImg="https://youtu.be/j5i--kxqjv8?autoplay=1&mute=1&enablejsapi=1&color=white&controls=0&modestbranding=1&playsinline=1&rel=0"
        title="Switch to Solar, Power Your Future"
        subTitle="Welcome to Riyansh Solar Power Plus Pvt. Ltd. - Your trusted partner in premium renewable energy solutions and lucrative solar franchise opportunities across India."
        srcUrl="/contact"
      />

      <Section>
        <MovingTextSection data={movingTextData} />
      </Section>

      <Section
        pt="135"
        ptLg="75"
        pb="140"
        pbLg="80"
        className="position-relative"
      >
        <AboutUsSection
          thumbUrl="https://i.ibb.co/Lz4f5LC7/Whats-App-Image-2025-12-06-at-14-02-33.jpg"
          experienceBgUrl="https://t3.ftcdn.net/jpg/09/76/62/26/360_F_976622688_UP2HewCWKm7KkUjKNkN4EKP5Yp1krVsc.jpg"
            experienceIconUrl="/images/experience_icon.svg"
          experienceNumber="10"
          experienceTitle="Work Experience"
          sectionTitleUp="Our Introduction"
          sectionTitle='Join India<span className="text-accent"> Leading Solar Franchise Network</span>'
          sectionSubTitle="Riyansh Solar Power Plus Pvt. Ltd. stands as your premier solar franchise partner in India, delivering innovative, cost-effective renewable energy solutions. As an ISO-certified JV manufacturer, energy consultant, and EPC expert, we excel in residential, commercial, and industrial solar power projects with pan-India presence."
          grothTitle="Franchise Success Rate"
          grothPercentage="90"
          featureList={[
            {
              title: 'Comprehensive Solar Portfolio',
              subTitle: 'On-Grid, Off-Grid, Hybrid systems, Solar Water Pumps, EV Chargers, and Smart Energy Solutions',
            },
            {
              title: 'End-to-End Business Ecosystem',
              subTitle: 'Complete training, premium marketing collateral, technical support, and 24/7 expert guidance',
            },
          ]}
          btnText="Become a Partner"
          btnUrl="/business_franchise"
          videoBtnText="Watch Success Stories"
          videoBtnUrl="https://www.youtube.com/embed/j5i--kxqjv8"
        />
      </Section>

      <Section pt="140" ptLg="80" pb="140" pbLg="80" className="cs_gray_bg">
        <FunfactSection
          sectionTitleUp="Our Milestones"
          sectionTitle="Driving India's Solar Revolution"
          sectionSubTitle="Pioneering renewable energy adoption with cutting-edge technology and sustainable business practices across the nation."
          data={funfactData}
          imgUrl="https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80"
          shapeImgUrl="https://images.unsplash.com/photo-1542744095-fcf48d80b0fd?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80"
        />
      </Section>
    <ServicesSection/>
      <Section pt="100" ptLg="75" pb="100" pbLg="55">
        <div className="container">
          <div className="portfolio-heading text-center">
            <h2 className="main-title">Our Premium Solar Projects</h2>
            <p className="subtitle">
              Showcasing excellence in solar energy solutions across diverse sectors with cutting-edge technology and impeccable execution.
            </p>
          </div>

          <div className="portfolio-grid">
            {portfolioItems.map((item, index) => (
              <div className="portfolio-item" key={index}>
                {item.type === 'image' ? (
                  <img src={item.src} alt={item.title} className="portfolio-media" />
                ) : (
                  <div className="iframe-wrapper">
                    <iframe
                      src={`${item.src}?autoplay=0&mute=1&rel=0&modestbranding=1`}
                      title={item.title}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      frameBorder="0"
                      allowFullScreen
                    ></iframe>
                  </div>
                )}
                <div className="portfolio-overlay">
                  <h4 className="portfolio-item-title">{item.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Section>

      {/* <Section pt="120" pb="100" className="cs_blue_bg">
        <TeamSection
          data={teamData}
          sectionTitle="Meet Our Visionary <br/>Leadership Team"
          sectionTitleUp="Industry Experts"
        />
      </Section> */}

      <Section
        pt="100"
        pb="100"
        style={{ 
          backgroundImage: `url('https://e0.pxfuel.com/wallpapers/210/864/desktop-wallpaper-solar-panels-solar-farm.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <TestimonialSection
          sectionTitleUp="Client Testimonials"
          sectionTitle="Success Stories That Inspire"
          sectionSubTitle="Discover how our clients and franchise partners are achieving energy independence and business success with our solar solutions."
          data={testimonialData}
        />
      </Section>

      <Section
        pt="133"
        ptLg="75"
        pb="140"
        pbLg="80"
        className="background-filled overflow-hidden"
        style={{ 
          backgroundImage: `linear-gradient(135deg, rgba(10, 50, 100, 0.9), rgba(0, 150, 200, 0.8)), url('https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <ContactSection
          sectionTitleUp="Get In Touch"
          sectionTitle="Ready to Harness Solar Power?"
          sectionSubTitle="Join India's renewable energy revolution with Riyansh Solar Power Plus. Get comprehensive solutions for residential, commercial, and industrial solar needs with guaranteed performance."
          textVarient="text-white"
          className="cs_mb_40"
          sectionImgUrl="https://images.unsplash.com/photo-1613665813446-82a78c468a1d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2058&q=80"
       contactInfo={[
            {
              imgUrl: '/images/icons/contact_icon_1.svg',
              titleUp: 'Have Any Question?',
              title: '+91 91520 23390',
              textColor: 'text-white',
            },
            {
              imgUrl: '/images/icons/contact_icon_2.svg',
              titleUp: 'Send Email',
              title: 'Info@riyanshsolar.com',
              textColor: 'text-white',
            },
            {
              imgUrl: '/images/icons/contact_icon_3.svg',
              titleUp: 'Address',
              title: ' Office No 3 Venkatesh Plaza Balaji Nagar Station Road Bhayandar West Thane 401101 Maharashtra',
              textColor: 'text-white',
            },
          ]}
        />
      </Section>

      <FranchiseForm/>
    </>
  );
}